<template>
  <el-dialog
    :title="
      model.id
        ? `编辑${model.category == 1 ? '零件' : '复合片'}`
        : `添加${model.category == 1 ? '零件' : '复合片'}`
    "
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <!-- <el-form-item label="分类">
        <el-select v-model="model.category" class="long">
          <el-option key="1" label="零件" :value="1"></el-option>
          <el-option key="2" label="复合片" :value="2"></el-option>
        </el-select>
      </el-form-item> -->
      <template v-if="model.category == 1">
        <el-form-item label="名称" prop="name">
          <el-input v-model="model.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="model.code"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="specification">
          <el-input v-model="model.specification"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="model_number">
          <el-input v-model="model.model_number"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="model.unit"></el-input>
        </el-form-item>
      </template>
      <template v-if="model.category == 2">
        <el-form-item label="规格" prop="specification">
          <el-input v-model="model.specification"></el-input>
        </el-form-item>
        <el-form-item label="倒角" prop="chamfering">
          <el-input v-model="model.chamfering"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="model.code"></el-input>
        </el-form-item>
        <el-form-item label="直径" prop="diameter">
          <el-input v-model.number="model.diameter"></el-input>
        </el-form-item>
        <el-form-item label="齿形" prop="tooth_type">
          <el-input v-model="model.tooth_type"></el-input>
        </el-form-item>
        <el-form-item label="等级" prop="grade">
          <el-input v-model="model.grade"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="model.remark"></el-input>
      </el-form-item>

      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { commodityNew, commodityUpdate } from '@/service/getData'

export default {
  components: {},
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写名称' }],
        code: [{ required: true, message: '请填写编码' }],
        specification: [{ required: true, message: '请填写规格' }],
        chamfering: [{ required: true, message: '请填写倒角' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await commodityUpdate(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          } else {
            let res = await commodityNew(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>